/**
 * Display-only stock numbers.
 * Stored values stay at full precision. These helpers never add a thousands separator.
 * The decimal separator is always ".".
 */

export function formatStockQuantity(value, maximumFractionDigits = 4) {
  const number = Number(value);
  if (!Number.isFinite(number)) {
    return "0";
  }

  const fixed = number.toFixed(maximumFractionDigits).replace(/\.?0+$/, "");
  return fixed === "-0" ? "0" : fixed;
}

export function formatStockMoney(value, currency, empty = "-") {
  if (value == null || value === "") {
    return empty;
  }

  const number = Number(value);
  if (!Number.isFinite(number)) {
    return empty;
  }

  const amount = number.toFixed(2);
  return currency ? `${amount} ${currency}` : amount;
}
